import { ComponentNameEnum } from '@/types';

const getGameSlotSymbolsEditorFieldConfig = () => ({
  componentName: ComponentNameEnum.GAME_SLOT_SYMBOLS_EDITOR,
  options: {},
});

export default getGameSlotSymbolsEditorFieldConfig;
